import { joinParams } from '../utils'

export default {

  /**
   * 查询用户下的 子账户
   * 
   * @param {Number} userId
   */
  getSubUsers(params) {
    return this.instance.get('/api/oms/user/subUsers', {
      params: params
    })
  },

  /**
   * 查询管理员账户拥有的子角色
   * @param {Number} userId 
   */
  getSubRoles(params) {
    return this.instance.get('/api/oms/user/subRoles', {
      params: params
    })
  },

  /**
   * 新建XMS角色
   * 
   * @param {String} name 角色名称
   * @param {String} remark 角色描述
   * @param {String} createName 创建人
   * @param {Number} userId  所属用户id， 当前登录用户
   * @param {String} funtionIds 权限id
   * @param {Number} sourceId 角色来源 1-OMS， 2-XMS
   */
  createNewRole(params) {
    return this.instance.post('/api/oms/role', joinParams(params))
  },

  /**
   * 编辑XMS角色
   * 
   * @param {String} name 角色名
   * @param {String} remark 角色描述
   * @param {String} funtionIds 权限Id列表， 逗号分隔
   * @param {Number} roleId 角色Id
   * @param {Number} userId 编辑人用户Id
   */
  updateRole(params) {
    return this.instance.put('/api/oms/role', joinParams(params))
  },

  /**
   * 删除XMS角色
   * 
   * @param {Number} roleId 角色Id
   */
  deleteRole(params) {
    return this.instance.delete('/api/oms/role', {
      params: params
    })
  },

  /**
   * 新建XMS用户
   * @param {String} username 用户名
   * @param {String} password 密码
   * @param {Number} sourceId 角色来源 1-OMS 2-XMS
   * @param {String} roleIds 
   * @param {Number} parentId 
   * @param {String} mobile 
   */
  createNewUser(params) {
    return this.instance.post('/api/oms/xms/user', joinParams(params))
  },

  /**
   * 编辑XMS用户
   * @param {String} username 
   * @param {String} password 
   * @param {Array} sourceId 
   * @param {String} roleIds 
   * @param {String} mobile 
   * @param {String} id 要编辑账户的id 
   * @param {String} parentId 父级id 
   */
  updateUser(params) {
    return this.instance.put('/api/oms/xms/user', joinParams(params))
  },

  /**
   * 删除用户
   * @param {Number} userId 
   */
  deleteUser(params) {
    return this.instance.delete('/api/oms/xms/user', {
      params: params
    })
  },

  /**
   * 根据角色查询权限
   * @param {Number} roleId 
   */
  searchRolePower(params) {
    return this.instance.get('/api/oms/role/powers', {
      params: params
    })
  },

  /**
   * 根据用户Id查询权限
   * @param {Number} userId 
   * @param {Number} sourceId 
   */
  getUserPowers(params) {
    return this.instance.get('/api/oms/user/powers', {
      params: params
    })
  },

  /**
   * 批量添加更新用户房间数据范围
   * @param {Array} omsNewRoomsRangeList
    * @param {String} value 根据type判断传值门店id，行政区域名称，城市名称
    * @param {Number} userId 用户id
    * @param {String} name 展示名称，id_门店名称, 城市-行政区
    * @param {Number} type 房间数据范围类型，1城市 2行政区 3门店
   * @param {Number} isAll 1添加所有房间查看， 2删除
   * @param {Number} userId 用户id（必传）
   */
  updateUserRoomRange(params) {
    return this.instance.post('/api/oms/batchAddOmsUserRoomsRange', joinParams(params))
  }
}


// WEBPACK FOOTER //
// ./src/api/rule.js